<div class="cancel-insurance-list-product">
    <div class="cancel-insurance-list-product__icon">
        <wuc-icon [icon]="icon" size="l"></wuc-icon>
    </div>
    <div class="cancel-insurance-list-product__description">
        <ng-content></ng-content>
    </div>
</div>
